import { getTokenFromStorage } from './common-logic';

/** Logged-in sessions should wait for user-info before showing any org logo. */
export function shouldWaitForOrgLogoApi(): boolean {
  return !!getTokenFromStorage();
}

export function isOrgLogoReady(userInitialized: boolean): boolean {
  return !shouldWaitForOrgLogoApi() || userInitialized;
}
